<div class="p-8 bg-gray-50 min-h-screen">
  <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-10 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-gray-900 tracking-tight">Diccionario de Seguridad</h1>
      <p class="text-gray-500 mt-1 italic">Control centralizado de Slugs y Módulos RMS.</p>
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
    @for (modulo of modulos(); track modulo.id) {
      <div class="bg-white rounded-3xl shadow-sm border border-gray-200 overflow-hidden flex flex-col hover:shadow-xl transition-all duration-300">

        <div class="p-6 border-b border-gray-100 bg-gradient-to-r from-gray-50 to-white">
          <div class="flex items-center gap-4">
            <div class="p-3 bg-indigo-600 text-white rounded-2xl shadow-lg shadow-indigo-100">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
              </svg>
            </div>
            <div>
              <h3 class="font-black text-gray-800 uppercase tracking-tight">{{ modulo.nombre }}</h3>
              <div class="flex items-center gap-2">
                <span class="text-[10px] font-bold text-indigo-500 bg-indigo-50 px-2 py-0.5 rounded-md">{{ modulo.slugRaiz }}</span>
                <span class="text-[9px] font-bold text-gray-400 uppercase tracking-widest">{{ modulo.area || 'SIN ÁREA' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="p-6 flex-grow">
          <div class="flex justify-between items-center mb-4">
            <span class="text-[10px] font-black text-gray-400 uppercase tracking-widest">Permisos del Sistema</span>
            <span class="text-[10px] font-bold text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">{{ modulo.listaPermisos?.length || 0 }}</span>
          </div>

          <div class="space-y-3 max-h-72 overflow-y-auto pr-2 custom-scrollbar">
            @for (p of modulo.listaPermisos; track p.id) {
              <div class="group flex items-center justify-between p-3 bg-gray-50 border border-transparent hover:border-indigo-100 hover:bg-white rounded-2xl transition-all">
                <div class="flex flex-col">
                  <span class="text-sm font-bold text-gray-700 group-hover:text-indigo-600">{{ p.nombre }}</span>
                  <span class="text-[10px] font-mono text-gray-400 tracking-tighter">{{ p.slug }}</span>
                </div>

                <div class="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-all">
                  <button (click)="editarPermiso(p, modulo)" class="p-2 text-gray-400 hover:text-indigo-600 hover:bg-indigo-50 rounded-xl transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"/></svg>
                  </button>
                  <button (click)="eliminarPermiso(p.id)" class="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-xl transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
                  </button>
                </div>
              </div>
            } @empty {
              <div class="py-10 text-center border-2 border-dashed border-gray-100 rounded-3xl">
                <p class="text-xs text-gray-400 italic">Módulo sin permisos configurados.</p>
              </div>
            }
          </div>
        </div>

        <div class="p-6 bg-gray-50/50 border-t border-gray-100">
          <button (click)="agregarPermisoRapido(modulo)"
            class="w-full py-3 bg-white border border-gray-200 text-gray-600 text-sm font-bold rounded-2xl hover:bg-indigo-600 hover:text-white hover:border-indigo-600 transition-all shadow-sm active:scale-95">
            + Vincular Permiso
          </button>
        </div>
      </div>
    }
  </div>
</div>
